import React from "react";
import { CalendarDays } from "lucide-react";
import { useVehicle } from "../../lib/vehicleContext";

/** Owner-set delivery date — warranty countdowns start from the true
 *  day one instead of an assumed model-year date. Stored per VIN. */
export const InServiceDateRow = () => {
  const { vehicle, setInServiceDate } = useVehicle();
  if (!vehicle?.live || !vehicle?.vin) return null;

  const val = vehicle.inServiceDate ? vehicle.inServiceDate.slice(0, 10) : "";
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div
      className="rounded-xl border p-3.5 flex items-center gap-3 mb-3"
      style={{ borderColor: "rgba(255,255,255,0.08)", background: "rgba(255,255,255,0.02)" }}
      data-testid="in-service-date-row"
    >
      <div
        className="w-9 h-9 rounded-lg flex items-center justify-center border shrink-0"
        style={{ background: "rgba(0,229,255,0.08)", borderColor: "rgba(0,229,255,0.30)" }}
      >
        <CalendarDays className="w-4 h-4" style={{ color: "#00E5FF" }} strokeWidth={2.4} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[12px] text-white font-semibold leading-snug">In-service date</div>
        <p className="font-mono text-[9px] text-zinc-500 leading-relaxed mt-0.5">
          {val
            ? "Warranty clocks count from your delivery day."
            : "Set your delivery day so warranty countdowns start from true day one."}
        </p>
      </div>
      <input
        type="date"
        value={val}
        max={today}
        onChange={(e) => setInServiceDate(vehicle.vin, e.target.value || null)}
        className="bg-transparent border border-white/10 rounded-lg px-2 py-1.5 text-[11px] text-zinc-300 font-mono focus:outline-none focus:border-white/25 shrink-0"
        style={{ colorScheme: "dark" }}
        data-testid="in-service-date-input"
      />
    </div>
  );
};
